import { call, put, take, fork } from 'redux-saga/effects';
import * as types from 'src/state/ducks/revenue/types';
import * as actions from 'src/state/ducks/revenue/actions';
import * as api from 'src/state/ducks/revenue/api';
import { Status } from 'src/constants/Interface';

function* getMonthRevenue() {
  while (true) {
    const { payload } = yield take(types.GET_MONTH_REVENUE);
    try {
      const res = yield call(api.getMonthRevenue, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successGetMonthRevenue(res));
      }
    } catch (err) {
      yield put(
        actions.failGetMonthRevenue({
          status: Status.FAILURE,
          error: {
            code: err.code | 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

const revenue = [fork(getMonthRevenue)];

export default revenue;
